import {Link, useNavigate} from 'react-router-dom';
import {Button} from '@heroui/react';
function ErrorFallback({error, resetErrorBoundary}) {
	let navigate = useNavigate();

	let title = 'Hiba történt';
	let message = 'valami itt nem stimmel...';
	let tryAgain = 'Újra próbálom';
	let back = 'Vissza';
	let reset = 'App újraindítása';

	console.error(JSON.stringify(error));

	const handleClickTryAgain = () => {
		resetErrorBoundary();
	};

	const handleClickBack = () => {
		navigate(-1);
	};

	const handleClickReset = () => {
		navigate('/');
		window.location.reload();
	};

	return (
		<div className='absolute top-0 left-0 w-full h-full flex flex-col items-center justify-center z-[999999] bg-black/80'>
			<div className='font-bold text-3xl text-white'>{title}</div>
			<div className='text-white/80 text-lg'>{message}</div>
			<div className='flex flex-col gap-2 w-full px-4'>
				<Button className='' color='secondary' size='md' fullWidth onPress={handleClickTryAgain}>
					{tryAgain}
				</Button>
				<Button className='' color='secondary' size='md' fullWidth onPress={handleClickBack}>
					{back}
				</Button>
				<Link to='/'>
					<Button fullWidth color='primary' onPress={handleClickReset}>
						{reset}
					</Button>
				</Link>
			</div>
		</div>
	);
}

export default ErrorFallback;
